import React from "react";
import Chart from "../components/Chart";
import AutoComplete from "../components/AutoComplete";

const Asbestos = props => {
  var withUpdates = props.testdata;

  props.updatedata.forEach(p => {
    withUpdates.forEach(w => {
      if (w.ULCS === p.ULCS && p.inPDF) {
        w.reports = p.reports;
      }
    });
  });

  var sorted = props.testdata
    .sort(function(a, b) {
      return b.reports - a.reports;
    })
    .slice(0, 10);

  return (
    <div>
      <div className="white-box asbestos">
        <h1>Damaged asbestos</h1>
        <div className="detailsection">
          <p>
            Asbestos can be found throughout schools built before 1980. It is
            wrapped around steam pipes as insulation, sprayed on walls and
            ceilings as soundproofing, and used to bind floor and ceiling tiles.
            A 1987 federal law requires school districts to inventory all
            locations of asbestos, monitor its condition, and note any damage.
          </p>
          <p>
            If kept in good condition, asbestos is not dangerous, but years of
            wear and tear can turn it into a silent killer if its fibers become
            airborne. There is no known level safe to breathe.
          </p>
          <p>
            Inhaled asbestos fibers can cause asbestosis, a debilitating lung
            disease; lung cancer; and mesothelioma, a rare aggressive cancer
            that develops in the lining of the lungs, abdomen or heart. Asbestos
            has also been linked to cancers of the esophagus, larynx, stomach,
            kidney, colon, rectum, and ovaries.
          </p>
          <p>
            The Philadelphia School District employs a specialized staff
            nicknamed the &ldquo;A Team&rdquo; that is trained to spot asbestos
            and safely handle its removal. Information on damaged asbestos in
            School Checkup comes from the district&rsquo;s most recent{" "}
            <a href="https://www.philasd.org/capitalprograms/programsservices/environmental/ahera/">
              asbestos inspections
            </a>
            , conducted during the 2015-16 school year.
          </p>
          <p>District staff do visual inspections every six months.</p>
          <p>
            Under federal law, schools are required to maintain and update
            asbestos-management plans, and allow the public to view them. For
            asbestos concerns, contact the school district&rsquo;s{" "}
            <a href="https://www.philasd.org/capitalprograms/programsservices/environmental/environmental-programs-services/">
              Department of Environmental Programs
            </a>{" "}
            &amp; Services at 215-400-4730.
          </p>

          <hr />
          <h3>Schools with highest number of damaged asbestos locations</h3>
          <Chart
            newdata={sorted}
            charttype="asbestos"
            chartlabel="Number of reports"
          />
        </div>
      </div>

      {/* <hr/>
        <div className="detailsection">


        </div> */}

      <div id="inputwrapper">
        <AutoComplete
          getUrl={props.match}
          data={props.data}
          placeholder="Search for another school..."
        />
      </div>
    </div>
  );
};

export default Asbestos;



// WEBPACK FOOTER //
// ./src/routes/Asbestos.js